import React, { FC, Suspense, useState } from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { Box, Alert, Snackbar } from "@mui/material";
import { AlertColor } from "@mui/material/Alert/Alert";
import TopAppBar from "components/navBar/ui/TopAppBar";

interface RootLayoutProps {}

const RootLayoutBox = styled(Box)`
  padding: 0;
  flex-grow: 1;
`;

const RootLayout: FC<RootLayoutProps> = () => {
  const [promptProps, setPromptProps] = useState<{
    isOpen: boolean;
    message: string;
    severity: AlertColor;
  }>({ isOpen: false, message: "", severity: "success" });

  /**
   * Handle prompt message close
   */
  const handlePromptClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string,
  ): void => {
    if (reason === "clickaway") {
      return;
    }

    setPromptProps({ ...promptProps, isOpen: false });
  };

  return (
    <RootLayoutBox>
      <Snackbar
        // anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={promptProps.isOpen}
        // autoHideDuration={6000}
        onClose={handlePromptClose}
      >
        <Alert
          onClose={handlePromptClose}
          severity={promptProps.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {promptProps.message}
        </Alert>
      </Snackbar>
      <TopAppBar />
      {/* Keep the Suspense boundary below the app bar: if the bar sat inside a
          boundary that re-suspends while a lazy page chunk loads, React 18
          would hide it and remount its layout effects, which leaves an open
          nav Menu's exit transition stranded and its backdrop stuck on screen */}
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </RootLayoutBox>
  );
};

export default RootLayout;
